import { observer } from 'mobx-react-lite';
import EmptyStateInfo from './EmptyStateInfo';
import { EmptyStateInfoProps, EmptyStateInfoValueProps } from './types';

export type { EmptyStateInfoProps, EmptyStateInfoValueProps };
export default observer(EmptyStateInfo);
